import React, { useState } from 'react';
import { Col, Alert, Form } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import CustomTableLoader from '../../common/CustomTableLoader';
import { GOTO_NEXT_STEP } from '../../../redux/actions/ActionTypes';

function Instructions() {
  const [loading, setloading] = useState(false);
  const ApplicationFormState = useSelector((state) => state.ApplicationForm);
  const { currentStep } = ApplicationFormState;
  const dispatch = useDispatch();
  let form = useSelector((state) => state.InstructionReducer);
  const { formValues = [] } = form;

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch({
      type: GOTO_NEXT_STEP,
      payload:
        currentStep == 1 && formValues.length == 0
          ? currentStep + 1
          : currentStep,
    });
  };

  return (
    <div>
      <Col md={12}>
        <Alert color="info">
          <h4 className="alert-heading">Read the Instructions Carefully</h4>
          <hr />
          <Form onSubmit={handleSubmit} id="instruction">
            {/* <ol className="instruction">
              <center>{loading && <CustomTableLoader />}</center>
              {formValues.map((data, key) => (
                <li key={key}>{data.selectedValue || '-'}</li>
              ))}
            </ol> */}
            <center>{loading && <CustomTableLoader />}</center>
            {formValues.map((data, key) => (
              <div
                className="view ql-editor"
                dangerouslySetInnerHTML={{
                  __html: data.selectedValue,
                }}
              ></div>
            ))}
          </Form>
        </Alert>
      </Col>
    </div>
  );
}

export default Instructions;
